/* istanbul ignore file */
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleVacancyGroupPublicationBreadcrumbs from 'domain/recruiting/newVacancy/show/publications/shared/SingleVacancyGroupPublicationBreadcrumbs';

const UpdateVacancyPublicationBreadcrumbs = () => {
  return (
    <SingleVacancyGroupPublicationBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleVacancyGroupPublicationBreadcrumbs>
  );
};

export default UpdateVacancyPublicationBreadcrumbs;
